import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataTable.APItemReceiveCell`

export default defineMessages({
  exceptionIconLabel: {
    id: `${scope}.exceptionIconLabel`,
    defaultMessage: 'Exception icon',
  },
  informationIconLabel: {
    id: `${scope}.informationIconLabel`,
    defaultMessage: 'Information icon',
  },
})
